import type { KeyData } from '@/components/Chart/types/chartData';
import type { TemplateChartSeries } from '@/types/charts';

export function findSeriesBasedOnKey(
  templateChartSeries: TemplateChartSeries[] | undefined,
  key: KeyData
) {
  return templateChartSeries?.find(series => {
    const k = series.symbol.key;
    return (
      k.Code === key.Code &&
      k.PeriodType === key.PeriodType &&
      k.Period === key.Period &&
      k.TimeRef === key.TimeRef
    );
  });
}
